import assets from '../asset.json';
import { EnumField } from '../components/input';


export default function AssetField(props) {
  const opt = assets.map(a=>({value:a.id, label:a.id}));
  return <EnumField name="asset" label="Szállítás módja" options={opt} {...props}/>
}